export const processContent = {
  title: 'How We Work',
  subtitle: 'From use case to production, built for how Retail and CPG teams operate',
  steps: [
    {
      number: '01',
      title: 'Discover',
      description:
        'We map commercial goals, existing systems, and where AI can move demand, margin, or operations',
    },
    {
      number: '02',
      title: 'Design',
      description: 'Define the use cases, data architecture, and rollout plan that fit how your teams work',
    },
    {
      number: '03',
      title: 'Build',
      description:
        'Develop models, pipelines, and integrations with regular check-ins against business outcomes',
    },
    {
      number: '04',
      title: 'Launch',
      description: 'Put into production with monitoring, documentation, and enablement for your teams',
    },
  ],
};
